<template>
  <div class="g-table">
    <el-table
      id="dailyworkTable"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      height="100%"
      border
      stripe
      @selection-change="selectionChange"
    >
      <!-- check-->
      <el-table-column
        align="center"
        type="selection"
        width="34"
        :selectable="jinzhi"
      ></el-table-column>
      <!-- 姓名 -->
      <el-table-column
        align="center"
        label="姓名"
        min-width="110"
        :formatter="cnName"
      ></el-table-column>
      <!-- 项目名称 -->
      <el-table-column
        align="center"
        label="项目名称"
        prop="project_name_cn"
        min-width="180"
      >
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.xiangmucn"
            size="small"
            @change="gaibianXiangmu(scope.row, scope.$index, $event)"
            v-if="CtimeFlag == 'open' && scope.row.is_confirmed == 0"
          >
            <el-option
              v-for="item in xiangmuList"
              :label="item.project_name_cn"
              :value="item.project_id"
              :key="item.project_id"
            ></el-option>
          </el-select>
          <div v-else>
            {{
              typeof scope.row.xiangmucn == "undefined"
                ? scope.row.project_id
                : scope.row.xiangmucn
            }}
          </div>
        </template>
      </el-table-column>
      <!-- 阶段部门 -->
      <!-- <el-table-column
        align="center"
        label="阶段部门"
        style="display:inline-block;float:left;"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.depart_id"
            placeholder="请选择"
            size="small"
            popper-class="select-option"
            @change="getjieduan(scope.$index,$event)"
            v-if="CtimeFlag == 'open' && scope.row.is_confirmed == 0"
          >
            <el-option
              v-for="item in jieduanId.depart_list"
              :key="item.depart_id"
              :label="item.depart_name"
              :value="item.depart_id"
            ></el-option>
          </el-select>
          <div v-else>{{ scope.row.bumencn }}</div>
        </template>
      </el-table-column>-->
      <!-- 阶段任务 -->
      <el-table-column align="center" label="阶段任务" min-width="150%">
        <template slot-scope="scope">
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="scope.row.value1"
            :options="scope.row.chioes"
            :props="{ expandTrigger: 'hover' }"
            :show-all-levels="false"
            @change="update(scope.$index)"
            v-if="CtimeFlag == 'open' && scope.row.is_confirmed == 0"
            :key="cascaderKey"
          ></el-cascader>
          <div v-else>{{ scope.row.task_name_str }}</div>
        </template>
      </el-table-column>
      <!-- 工作时长 -->
      <el-table-column align="center" label="工作时长(H:M)" width="120%">
        <template slot-scope="scope">
          <table
            frame="void"
            @change="update(scope.$index)"
            v-if="CtimeFlag == 'open' && scope.row.is_confirmed == 0"
            :class="{ myClass: Active == 1 }"
          >
            <tr>
              <td>
                <el-input
                  v-model="scope.row.show_hour"
                  size="small"
                  @change="update(scope.$index)"
                ></el-input>
              </td>
              <td>
                <el-input
                  v-model="scope.row.show_min"
                  size="small"
                  @change="update(scope.$index)"
                ></el-input>
              </td>
            </tr>
          </table>
          <div v-else>{{ scope.row.show_hour + ":" + scope.row.show_min }}</div>
        </template>
      </el-table-column>
      <!-- 工作内容 -->
      <el-table-column align="center" label="工作内容" width="400%">
        <template slot-scope="scope">
          <el-input
            type="textarea"
            autosize
            v-model="scope.row.comments"
            size="small"
            @change="update(scope.$index)"
            v-if="CtimeFlag == 'open' && scope.row.is_confirmed == 0"
          ></el-input>
          <div v-else>{{ scope.row.comments }}</div>
        </template>
      </el-table-column>
      <!-- 调休确认-->
      <el-table-column
        align="center"
        label="调休确认"
        width="100"
        :formatter="agrOverTime"
      ></el-table-column>
      <!-- 操作 -->
      <el-table-column align="center" label="操作" width="100%">
        <template
          slot-scope="scope"
          v-if="CtimeFlag == 'open' && scope.row.is_confirmed == 0"
        >
          <button
            @click="singlehandleAdd(scope.$index)"
            style="
              border: 0;
              background-color: transparent;
              outline: none;
              margin-right: 10px;
            "
          >
            <i class="el-icon-plus" style="color: blue; font-size: 16px"></i>
          </button>
          <button
            @click="tableDelete(scope.$index)"
            style="border: 0; background-color: transparent; outline: none"
          >
            <i class="el-icon-delete" style="color: red; font-size: 16px"></i>
          </button>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      type="text"
      size="Medium"
      @click="AddEmtyData"
      v-if="CtimeFlag == 'open' && Cyshangban == '1'"
    >
      <i class="el-icon-plus"></i>新增工作记录
    </el-button>
  </div>
</template>

<script>
import { getBaseInfo, getPerson } from "@/api/user";
import {
  hourToMin,
  gettaskOptions,
  getTaskOptionValue,
  gettasklistStrName,
  getpsheList,
} from "@/lib/until";
import axios from "axios";
export default {
  name: "GetTable",
  data() {
    return {
      base_info: [], //基础列表
      depart_id: "", //部门id
      personId: "", //人员id
      password: "",
      getdataxm: "", //人员姓名
      getdataId: "",
      options: [], //项目阶段
      jieduanId: "",
      cdepartid: "", //可变部门id
      intresOpt: [],
      Active: "",
      xiangmuList: [], //编辑状态下的下拉框
      cascaderKey: 0,
    };
  },
  props: {
    CtableData: {
      type: Array,
      default: [],
    },
    CtimeFlag: {
      type: String,
      default: "",
    },
    Cyshangban: {
      type: Number,
    },
  },
  created() {
    this.getuserInfo();
    this.getTableData();
  },
  computed: {
    tableData() {
      return this.CtableData;
    },
  },
  methods: {
    //项目的改变方法 //cuowu
    gaibianXiangmu(row, index, chaevent) {
      //console.log(row);
      //console.log(index);
      //console.log(chaevent);
      row.project_id = chaevent;
      row.value1 = [];
      getpsheList(row).then((res) => {
        ++this.cascaderKey;
        row.chioes = [];
        //console.log(row);
        row["chioes"] = gettaskOptions(row.depart_id, this.base_info, res);
      });
    },

    getjieduan(index, val) {
      // console.log(index);
      // console.log(val);
      this.update(index, val);
    },

    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.depart_id = uesrInfo.depart_ID;
      this.cdepartid = uesrInfo.depart_ID;
      this.personId = uesrInfo.employee_id;
      this.password = uesrInfo.password;
      //this.Active = window.localStorage.getItem("liang");
      //console.log(this.depart_id);
    },
    //禁止复选框选中
    jinzhi(row, index) {
      return row.is_confirmed == 0;
      //打开编辑页面
    },
    cnName(row, column) {
      //console.log(row.employee_id);
      if (row.employee_id == this.getdataId) {
        //console.log(this.getdataxm);
        return this.getdataxm;
      }
      // return row.address;
    },
    agrOverTime(row) {
      //console.log(row)
      if (row.is_confirmed == 1) {
        return "已确认";
      } else {
        return "";
      }
    },
    getTableData() {
      getBaseInfo().then((data) => {
        //console.log(data);
        this.base_info = data;
        this.jieduanId = data;
        //部门数组
        let bmlist = data.project_list;
        let newbmlist = Object.assign({}, bmlist);
        let newlist = [];
        //console.log(newbmlist);
        for (let key in newbmlist) {
          if (0 == newbmlist[key].all_payed) {
            //newbmlist[key].disabled = true;
            newlist.push(newbmlist[key]);
          }
        }
        //console.log(newlist);
        this.xiangmuList = newlist;
        this.xiangmuList.sort(function (a, b) {
          return a.order_id - b.order_id;
        });

        getPerson(this.depart_id).then((data) => {
          //console.log(data);
          this.getDepartAndProjectData = data;
          this.getdataxm =
            this.getDepartAndProjectData.employee_list[
              this.personId
            ].employee_name;
          this.getdataId =
            this.getDepartAndProjectData.employee_list[
              this.personId
            ].employee_id;
          //console.log(this.base_info.phase_list);
          let jieduan = this.getDepartAndProjectData.task_list;
          let gettaskList = this.base_info;
          //console.log(gettaskList);
          this.$emit("getData", gettaskList);
        });
      });
    },
    //增加行
    AddEmtyData() {
      //console.log(this.getshuzu(this.depart_id));
      var v = {
        employee_id: this.getdataId,
        employee_name: "",
        project_id: "",
        task_id: "",
        daily_report_id: -1,
        phase_id: "",
        value1: [],
        work_hour: "",
        show_hour: "0",
        show_min: "0",
        overtimework: false,
        comments: "空",
        is_confirmed: 0,
        depart_id: this.depart_id,
        chioes: [],
      };
      this.tableData.push(v);
      this.$nextTick(() => {
        this.$refs.multipleTable.bodyWrapper.scrollTop =
          this.$refs.multipleTable.bodyWrapper.scrollHeight;
      });
    },
    //提交数据
    update(index, xzdepartid) {
      var Msg = this.tableData[index];
      //console.log(Msg);
      this.checkInput(Msg);
      Msg.work_hour = 0;
      var otherHourSum = this.getEmployeeWorkHoursSum(Msg.employee_id);
      //console.log(otherHourSum);
      this.minToHour(Msg);
      //9console.log(Msg.work_hou);
      //console.log(otherHourSum);

      var totalSum = Number(Msg.work_hour) + otherHourSum;
      //console.log(totalSum);
      //console.log(totalSum);
      //console.log(totalSum);
      if (totalSum <= 8.01 && totalSum >= 7.99) {
        // alert("工作时长总和超8小时请修改");
        // this.Active = 1;
        Msg.work_hour = String((8 - otherHourSum).toFixed(3));
        //window.localStorage.setItem("liang",this.Active);
        //console.log(Msg.work_hour);
      }
      if (totalSum > 8.01) {
        alert("工作时长总和超8小时请修改");
        this.Active = 1;
        //Msg.work_hour = String((8 - otherHourSum).toFixed(3));
        //window.localStorage.setItem("liang",this.Active);
      } else {
        this.Active = 0;
        //window.localStorage.removeItem("liang");
      }
      console.log(Msg);
      if (xzdepartid) {
        Msg.chioes = [];
        //console.log(111);
        Msg.depart_id = xzdepartid;
        //console.log(Msg.chioes);
        Msg.chioes = gettaskOptions(xzdepartid, this.base_info);
        //console.log(Msg);
      } else {
        Msg.daily_report_date = this.$root.Time;
        if (Msg.daily_report_id != -1) {
          this.$http
            .post(
              IPConfig.IP + "/kpi-management/dailyreport/update.php",
              JSON.stringify(this.updateJSONmsg(Msg)),
              { emulateJSON: true }
            )
            .then();
        } else if (
          Msg.employee_id != "" &&
          Msg.project_id != "" &&
          Msg.value1.length != 0 &&
          Msg.comments != "" &&
          Msg.show_hour != "" &&
          Msg.show_min != ""
        ) {
          //console.log("获取")
          var addMsg = this.updateJSONmsg(Msg);
          this.$http
            .post(
              IPConfig.IP + "/kpi-management/dailyreport/create.php",
              JSON.stringify(addMsg),
              { emulateJSON: true }
            )
            .then(function (res) {
              var getDaily_report_id = res.body;
              addMsg.daily_report_id = getDaily_report_id.daily_report_id;
              console.log(getDaily_report_id.daily_report_id);
              this.$http
                .post(
                  IPConfig.IP + "/kpi-management/dailyreport/update.php",
                  JSON.stringify(addMsg),
                  { emulateJSON: true }
                )
                .then(function (res) {
                  //console.log(res.body);
                });
            });
        }
      }
    },
    checkInput(vms) {
      if (isNaN(Number(vms.show_hour))) {
        vms.show_hour = "0";
      }
      var tempMin = Number(vms.show_min);
      if (isNaN(tempMin) || tempMin < 0) {
        vms.show_min = "0";
      } else if (tempMin > 59) {
        vms.show_min = "59";
      }
    },
    getEmployeeWorkHoursSum(employee_id) {
      var sum = 0;
      for (var i = 0; i < this.tableData.length; i++) {
        if (employee_id == this.tableData[i].employee_id) {
          sum += Number(this.tableData[i].work_hour);
        }
      }
      return sum;
    },
    minToHour(vms) {
      //work_hour格式化
      var hourvalue = Number(vms.show_hour) + Number(vms.show_min) / 60;
      vms.work_hour = String(hourvalue.toFixed(3));
    },
    updateJSONmsg(updateMsg) {
      if (updateMsg.value1.length == 3) {
        updateMsg.task_id = updateMsg.value1[2];
        updateMsg.phase_id = updateMsg.value1[0];
      }
      if (updateMsg.value1.length == 2) {
        updateMsg.task_id = updateMsg.value1[1];
        updateMsg.phase_id = updateMsg.value1[0];
      }
      //转成JSON数据
      return updateMsg;
      //发送数据
    },

    formatter(row, column) {
      //console.log(row.employee_id);
      if (row.employee_id == this.getdataId) {
        //console.log(this.getdataxm);
        return this.getdataxm;
      }
    },

    // //生成excel表格
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    exportToExcel() {
      var printdailyworktable = [];
      printdailyworktable = this.getHeadername();

      console.log(printdailyworktable);
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../vendor/Export2Excel");
        const tHeader = [
          "日期",
          "姓名",
          "部门",
          "项目",
          "项目阶段",
          "上班时长",
          "工作内容",
        ];
        const filterVal = [
          "date",
          "name",
          "depart",
          "project",
          "phase_task",
          "work_hour",
          "comments",
        ];
        const list = printdailyworktable;
        const data = this.formatJson(filterVal, list);
        var exceldepart_name = "";
        var departIdKeys = Object.keys(this.base_info.depart_list);
        for (var n = 0; n < departIdKeys.length; n++) {
          if (
            this.depart_id ==
            this.base_info.depart_list[departIdKeys[n]].depart_id
          )
            exceldepart_name =
              this.base_info.depart_list[departIdKeys[n]].depart_name;
        }
        export_json_to_excel(
          tHeader,
          data,
          "个人日工作_" + this.$root.Time + "_" + exceldepart_name
        );
      });
    },
    getHeadername() {
      var printTabledata = [];
      var exceltablerowdata = {
        date: "",
        name: "",
        depart: "",
        project: "",
        phase_task: "",
        work_hour: "",
        comments: "",
      };

      //获取id对应的中文名称
      var employeeIdKeys = Object.keys(
        this.getDepartAndProjectData.employee_list
      );
      var taskIdKeys = Object.keys(this.getDepartAndProjectData.task_list);
      var projectIdKeys = Object.keys(this.base_info.project_list);
      var departIdKeys = Object.keys(this.base_info.depart_list);
      //console.log('111');
      for (var i = 0; i < this.tableData.length; i++) {
        let tablerowdata = Object.assign({}, exceltablerowdata);
        for (var k = 0; k < employeeIdKeys.length; k++) {
          if (
            this.tableData[i].employee_id ==
            this.getDepartAndProjectData.employee_list[employeeIdKeys[k]]
              .employee_id
          )
            tablerowdata.name =
              this.getDepartAndProjectData.employee_list[
                employeeIdKeys[k]
              ].employee_name;
        }
        for (var j = 0; j < taskIdKeys.length; j++) {
          var sub_taskKeys = Object.keys(
            this.getDepartAndProjectData.task_list[taskIdKeys[j]].sub_task
          );
          if (
            this.tableData[i].task_id ==
            this.getDepartAndProjectData.task_list[taskIdKeys[j]].task_id
          ) {
            var sub_taskKeys = Object.keys(
              this.getDepartAndProjectData.task_list[taskIdKeys[j]].sub_task
            );
            tablerowdata.phase_task =
              this.getDepartAndProjectData.task_list[taskIdKeys[j]].task_abbr +
              "." +
              this.getDepartAndProjectData.task_list[taskIdKeys[j]]
                .task_name_cn;
          } else {
            for (var v = 0; v < sub_taskKeys.length; v++) {
              if (
                this.tableData[i].task_id ==
                this.getDepartAndProjectData.task_list[taskIdKeys[j]].sub_task[
                  sub_taskKeys[v]
                ].task_id
              ) {
                tablerowdata.phase_task =
                  this.getDepartAndProjectData.task_list[taskIdKeys[j]]
                    .sub_task[sub_taskKeys[v]].task_abbr +
                  "." +
                  this.getDepartAndProjectData.task_list[taskIdKeys[j]]
                    .sub_task[sub_taskKeys[v]].task_name_cn;
              }
            }
          }
        }
        for (var m = 0; m < projectIdKeys.length; m++) {
          if (
            this.tableData[i].project_id ==
            this.base_info.project_list[projectIdKeys[m]].project_id
          )
            tablerowdata.project =
              this.base_info.project_list[projectIdKeys[m]].project_name_cn;
        }
        for (var n = 0; n < departIdKeys.length; n++) {
          if (
            this.depart_id ==
            this.base_info.depart_list[departIdKeys[n]].depart_id
          )
            tablerowdata.depart =
              this.base_info.depart_list[departIdKeys[n]].depart_name;
        }

        tablerowdata.work_hour = this.tableData[i].work_hour;
        tablerowdata.comments = this.tableData[i].comments;
        tablerowdata.date = this.$root.Time;
        //console.log(tablerowdata);
        printTabledata.push(tablerowdata);
        tablerowdata = {};
      }
      return printTabledata;
    },

    selectionChange(selection) {
      this.checked = selection;
    },
    //多行删除时用
    checkedDelete() {
      //console.log(this.checked);
      if (this.checked == undefined) {
        alert("至少先选择一条数据");
        return;
      }
      this.$confirm("确定批量删除数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
            duration: "500",
          });
          var delete_report_list = {
            delete_report_list: [],
          };
          this.checked.forEach(function (value) {
            //console.log(value.daily_report_id);
            var deleterowReportID = { daily_report_id: -1 };
            deleterowReportID.daily_report_id = value.daily_report_id;
            delete_report_list.delete_report_list.push(deleterowReportID);
            this.tableData.splice(this.tableData.indexOf(value), 1);
          }, this);
          this.$http.post(
            IPConfig.IP + "/kpi-management/dailyreport/delete.php",
            JSON.stringify(delete_report_list),
            { emulateJSON: true }
          );
        })
        .catch(() => {});
    },
    //单行删除按钮
    tableDelete(index) {
      //console.log(this.tableData[index].daily_report_id);
      this.$confirm("确定删除这条记录吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
            duration: "500",
          });
          var deleteMsg = {
            delete_report_list: [
              {
                daily_report_id: 0,
              },
            ],
          };
          deleteMsg.delete_report_list[0].daily_report_id =
            this.tableData[index].daily_report_id;
          this.tableData.splice(index, 1);
          //alert(this.tableData[index].daily_report_id);
          this.$http.post(
            IPConfig.IP + "/kpi-management/dailyreport/delete.php",
            JSON.stringify(deleteMsg),
            { emulateJSON: true }
          );
        })
        .catch(() => {});
    },
    //单个人添加
    singlehandleAdd(index) {
      let singleAdd = Object.assign({}, this.tableData[index]);
      var employee_id = this.tableData[index].employee_id;
      var sumHours = this.getEmployeeWorkHoursSum(employee_id);
      var remainHours = 8 - sumHours;
      singleAdd.work_hour = remainHours.toString();
      hourToMin(singleAdd);
      singleAdd.daily_report_id = -1;
      var i = index + 1;
      this.tableData.splice(i, 0, singleAdd);
      //console.log(i,this.tableData[i]);
      //this.tableData[i].daily_report_id=-1;
      this.update(i);
    },
  },
};
</script>

<style scoped lang="less">
.g-table {
  margin-top: 20px;
}
.page-title {
  font-size: 32px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 10px;
}
.breadcrumb {
  background-color: white;
  padding: 0.5rem;
  margin-bottom: 25px;
}
.table-container {
  border: 1px solid blue;
}
.form-container {
  padding: 10px;
}
.form-title {
  background-color: blue;
  color: white;
  padding: 0.5rem;
  text-align: left;
  margin-bottom: 5px;
}
.btn-container {
  overflow: hidden;
  .el-button {
    float: left;
  }
}
.search-input {
  width: 300px;
  float: left;
  margin-left: 10px;
  margin-right: 5px;
}
.el-table__body {
  td {
    padding: 0;
  }
}
.myClass {
  border: 1px red solid !important;
}
</style>


// WEBPACK FOOTER //
// src/views/PersonWork/GetTable.vue